import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const alertSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.alert, {
        variants: {
            status: {
                info: {
                    root: { colorPalette: 'secondary' },
                },
                // warning: {
                //     root: { colorPalette: 'orange' },
                // },
                // success: {
                //     root: { colorPalette: 'green' },
                // },
                error: {
                    root: { colorPalette: 'red' },
                },
            },
            variant: {
                subtle: {
                    root: {
                        bg: 'colorPalette.50',
                        color: '{colors.bodyText}',
                    },
                    title: {
                        fontWeight: 'bold',
                    },
                    indicator: {
                        color: 'colorPalette.fg',
                        fontSize: '2xl',
                    },
                },
            },
        },
        defaultVariants: {
            variant: 'subtle',
        },
    }),
);
